import SchoolTicketList from './_components/SchoolTicketList';

const SchoolTicketPage = () => {
  return (
    <>
      <SchoolTicketList />
    </>
  );
};

export default SchoolTicketPage;
